import { useMutation } from "@tanstack/react-query";
import api from "../services/api";

function useUploadImage() {
  const uploadMutation = useMutation(async (file) => {
    const filesArray = Array.isArray(file) ? file : [file];

    const uploadPromises = filesArray.map(async (singleFile) => {
      const formData = new FormData();
      formData.append("file", singleFile);

      const response = await api.post("/storage", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    });

    const results = await Promise.all(uploadPromises);
    return Array.isArray(file) ? results : results[0];
  });

  return {
    upload: uploadMutation.mutateAsync,
    isLoading: uploadMutation.isLoading,
    error: uploadMutation.error,
    reset: uploadMutation.reset,
  };
}

export default useUploadImage;
